import { useState } from "react";
import { Link } from "react-router-dom";
import { homeFaqs } from "@/mocks/faqs";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="FAQ"
              title="常见问题"
              description="第一次来的读者问得最多的问题，都在这里了。还有其他疑问，欢迎直接写信给我们。"
            />
            <Link
              to="/faq"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              查看全部问题
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-xl2 border border-background-200 bg-background-50">
              {homeFaqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.question}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left md:px-6"
                      aria-expanded={isOpen}
                    >
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {faq.question}
                      </span>
                      <i
                        className={`shrink-0 text-lg text-primary-500 transition-transform ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      ></i>
                    </button>
                    {isOpen && (
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">{faq.answer}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}